import React from 'react';
import Html from 'components/html';
import useIntersectionObserver from 'enhancers/use-intersection-observer';

import CategoryCard, { type CategoryCardElement } from './category-card';
import { testId } from './category-banner.settings';
import styles from './category-banner.module.scss';

interface CategoryBannerElement {
  cards: Array<CategoryCardElement>;
}

const CategoryBanner: React.FunctionComponent<CategoryBannerElement> = (props) => {
  const { cards } = props;
  const bannerRef = React.useRef<HTMLDivElement>(null);
  const [active, setActive] = React.useState(false);
  const inView = useIntersectionObserver(bannerRef, { threshold: 0.9 });

  React.useEffect(() => {
    if (!inView) return;

    setActive(true);
  }, [inView]);

  return (
    <Html.div className={[styles.categoryBanner, 'w-100']} testId={testId.component} ref={bannerRef}>
      {cards.map((card) => (
        <Html.div className={styles.card} key={card.category}>
          <CategoryCard
            src={card.src}
            category={card.category}
            name={card.name}
            nameVariant={card.nameVariant}
            active={active}
          />
        </Html.div>
      ))}
    </Html.div>
  );
};

export type { CategoryBannerElement };
export default CategoryBanner;
